export const Header = () => {
  return (
    <div className="header">
      <h1>Book a Book App</h1>
    </div>
  )
}
